export enum Brand {
    Excelsior = "Excelsior",
    Pigini = "Pigini",
    Serenellini = "Serenellini",
    Tula = "Tula",
    Other = "Other"
}